if (!customElements.get('frequently-bought-with')) {
  customElements.define('frequently-bought-with', class FrequentlyBoughtWith extends HTMLElement {
    constructor() {
      super();

      this.addButton = this.querySelector('.fbw__add');
      this.errorMessage = this.querySelector('.fbw__error');
      this.addLabel = this.addButton.textContent.trim();
      this.addButton.addEventListener('click', this.onAddClick.bind(this));
    }

    // Liquid's `t` filter and Shopify cart error descriptions arrive
    // HTML-escaped (&#39; etc.); decode before rendering via textContent.
    decodeEntities(text) {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      return doc.documentElement.textContent;
    }

    showError(text) {
      this.errorMessage.textContent = this.decodeEntities(text);
      this.errorMessage.hidden = false;
    }

    onAddClick() {
      const variantIds = Array.from(this.querySelectorAll('.fbw__checkbox:checked'))
        .map((checkbox) => parseInt(checkbox.value, 10));
      this.errorMessage.hidden = true;
      if (variantIds.length === 0) return;

      this.addButton.setAttribute('aria-disabled', 'true');
      this.addButton.classList.add('loading');

      // Always one-time purchases: no selling_plan. Subscription bundling is
      // handled by Skio/Bundle Builder, not this block.
      //
      // Deliberately NO theme cart-drawer/notification interaction here: this
      // store's cart UI is the UpCart app, which intercepts window.fetch for
      // /cart/add.js and opens its own drawer. The theme's <cart-drawer> is
      // unused (and opening it leaves an orphaned overflow-hidden scroll
      // lock on <body>). We just add and let the store's cart UX respond.
      const config = fetchConfig('javascript');
      config.body = JSON.stringify({ items: variantIds.map((id) => ({ id, quantity: 1 })) });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || window.fbwStrings.error);
            return;
          }
          this.showAdded();
        })
        .catch((error) => {
          console.error(error);
          this.showError(window.fbwStrings.error);
        })
        .finally(() => {
          this.addButton.classList.remove('loading');
          this.addButton.removeAttribute('aria-disabled');
        });
    }

    showAdded() {
      this.addButton.textContent = window.fbwStrings.added;
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => {
        this.addButton.textContent = this.addLabel;
      }, 2500);
    }
  });
}
